module.exports = __webpack_public_path__ + "static/img/business6.1dac5c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business6.jpg
// module id = uFMG
// module chunks = 9